import { render } from "./indexpage.vue?vue&type=template&id=a84ac636&scoped=true"
import script from "./indexpage.vue?vue&type=script&lang=js"
export * from "./indexpage.vue?vue&type=script&lang=js"

import "./indexpage.vue?vue&type=style&index=0&id=a84ac636&scoped=true&lang=css"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-AfyunProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a84ac636"]])

export default __exports__